import { render, staticRenderFns } from "./dangerRegularCheckDetail.vue?vue&type=template&id=15cac971"
import script from "./dangerRegularCheckDetail.vue?vue&type=script&lang=js"
export * from "./dangerRegularCheckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15cac971')) {
      api.createRecord('15cac971', component.options)
    } else {
      api.reload('15cac971', component.options)
    }
    module.hot.accept("./dangerRegularCheckDetail.vue?vue&type=template&id=15cac971", function () {
      api.rerender('15cac971', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerRegularCheckDetail.vue"
export default component.exports